import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { Route } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import Constants from './Constants.js';

// Routes
import TermsAndConditions from "./Official/TermsAndConditions.js";
import PrivacyPolicy from "./Official/PrivacyPolicy.js";
import App from './App';

const startApp = () => {
    // Hide the status bar
    if (window.StatusBar)
        window.StatusBar.hide();

    // Router for web version
    const browserRouter = <BrowserRouter>
        <div>
            <Route path='/' exact component={App} />
            <Route path='/terms' component={TermsAndConditions} />
            <Route path='/privacy' component={PrivacyPolicy} />
        </div>
    </BrowserRouter>

    // Serve app, or browser router
    const content = ((window.cordova || Constants.coolmathVersion) ? <App /> : browserRouter);

    // Render app
    ReactDOM.render(content, document.getElementById('root'));
    //ReactDOM.render(<App />, document.getElementById('root'));
    serviceWorker.unregister();
};

if (window.cordova) {
    document.addEventListener('deviceready', startApp, false);
} else {
    startApp();
}

/*
Starter code:
*/

// ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
